import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { action, computed, set } from '@ember/object';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { task } from 'ember-concurrency';
import perform from 'ember-concurrency/helpers/perform';
// @ts-expect-error: Incorrect type
import preventDefault from 'ember-event-helpers/helpers/prevent-default';
import { not } from 'ember-truth-helpers';
import GeneralModalsModalSort from 'lumen/components/general/modals/modal-sort';

interface GeneralFilterBarEditFavouritesSignature {
  Args: {
    closeModal: unknown;
    favourites: unknown;
  };
}

export default class GeneralFilterBarEditFavourites extends Component<GeneralFilterBarEditFavouritesSignature> {
  @service declare alerting: Services['alerting'];
  @service declare errorTracking: Services['error-tracking'];

  // order need to be saved, so we put all changes in this temp variable
  tempFavourites = null;

  saveFavouritesTask = task({ keepLatest: true }, async () => {
    const oldFavourites = this.args.favourites;
    const newFavourites = this.tempFavourites;
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    const newFavouriteIds = newFavourites.map((favourite) => favourite.id);
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const deletedFavourites = oldFavourites.filter(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      (oldFavourite) => newFavouriteIds.indexOf(oldFavourite.id) === -1,
    );
    // @ts-expect-error: Incorrect type
    const errors = [];

    const deletedFavouritesIds = [];
    const destroyRecordPromises = [];

    // Destroy favourites marked as deleted
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    for (let i = 0; i < deletedFavourites.length; i++) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const favouriteId = deletedFavourites[i].id;

      try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        destroyRecordPromises.push(deletedFavourites[i].destroyRecord());
        deletedFavouritesIds.push(favouriteId);
      } catch (error) {
        this.errorTracking.captureMessage('Failed to destroy favourites: ', {
          error,
        });
      }
    }

    await Promise.all(destroyRecordPromises).then((responses) => {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      responses.forEach((response) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (response?.errors.length) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
          errors.push(...response.errors);
        }
      });

      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return errors;
    });

    const saveNewFavouritesPromises = [];

    // Update favourites order
    // @ts-expect-error: Incorrect type
    for (let i = 0; i < newFavourites.length; i++) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
      const favourite = oldFavourites.filter(
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (oldFavourite) => newFavourites[i].id === oldFavourite.id,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      )[0];
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      set(favourite, 'order', newFavourites[i].order);
      try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        saveNewFavouritesPromises.push(favourite.save());
      } catch (error) {
        this.errorTracking.captureMessage('Failed to update favourites: ', {
          error,
        });
      }
    }

    await Promise.all(saveNewFavouritesPromises).then((responses) => {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      responses.forEach((response) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (response.errors.length) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
          errors.push(...response.errors);
        }
      });

      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return errors;
    });

    if (errors.length) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.alerting.showErrorAlert({
        // @ts-expect-error: Incorrect type
        htmlContent: errors,
      });
    }

    // @ts-expect-error: Incorrect type
    this.args.closeModal();
  });

  @computed('args.favourites.[]', 'hasDeletedFavourite', 'tempFavourites.[]')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get deleteOrOrderChanged() {
    // Called toArray because the get did not return an array but an object
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const isEnabled =
      this.hasDeletedFavourite ||
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      (this.args.favourites ?? []).some(
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (favourite, index) => favourite.id !== this.tempFavourites[index].id,
      );
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return isEnabled;
  }

  @computed('tempFavourites.length', 'args.favourites.length')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasDeletedFavourite() {
    // @ts-expect-error: Incorrect type
    return this.tempFavourites?.length !== this.args.favourites?.length;
  }

  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  mapFavourites(favourites) {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return favourites.map((favourite, index) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const { id, name, hotel, market, pageType, filters } = favourite;
      return {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        id,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        name,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        hotel,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        market,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        pageType,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        filters,
        isHovered: false,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        order: index + 1,
      };
    });
  }

  @action
  cancelFavourites(): void {
    set(this, 'tempFavourites', this.mapFavourites(this.args.favourites));
    // @ts-expect-error: Incorrect type
    this.args.closeModal();
  }

  @action
  // @ts-expect-error: Incorrect type
  deleteFavourite(favourite): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const remainingFavourites = this.tempFavourites.filter(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (tempFavourite) => tempFavourite.id !== favourite.id,
    );
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const reorderedFavourites = this.mapFavourites(remainingFavourites);
    set(this, 'tempFavourites', reorderedFavourites);
  }

  @action
  // @ts-expect-error: Incorrect type
  reorderFavourites(groupModel): void {
    set(this, 'tempFavourites', this.mapFavourites(groupModel));
  }

  @action
  setTempFavourites(): void {
    set(this, 'tempFavourites', this.mapFavourites(this.args.favourites));
  }

  <template>
    <div {{didInsert this.setTempFavourites}}>
      <GeneralModalsModalSort
        {{! @glint-expect-error: Incorrect type }}
        @items={{this.tempFavourites}}
        @onCancel={{this.cancelFavourites}}
        @onReorder={{this.reorderFavourites}}
        @onSave={{perform this.saveFavouritesTask}}
        @saveDisabled={{not this.deleteOrOrderChanged}}
        as |item|
      >
        <div class="handle-container {{if item.isHovering 'highlighted'}}">
          <div class="handle flex items-center justify-end">
            <PrismIcon @name="drag" />
          </div>
          <div class="highlight-value position truncate">
            {{! @glint-expect-error: Incorrect type }}
            {{item.order}}
          </div>
          <div class="highlight-value item-name truncate">
            {{! @glint-expect-error: Incorrect type }}
            {{item.name}}
          </div>
        </div>
        <div class="action-container">
          <button
            class="button--unstyled"
            data-test-id="favourites-delete-button"
            type="button"
            {{on "click" (preventDefault (fn this.deleteFavourite item))}}
          >
            <PrismIcon @name="bin" @size="small" />
          </button>
        </div>
      </GeneralModalsModalSort>
    </div>
  </template>
}
